import {atom} from 'jotai';

export const initialState = {
    effortLevel: [],
    mainIngredients: [],
    cookingTime: [],
    course: [],
    diet: [],
    style: [],
    fuelType: [],
    featured:[],
    orderby: '&orderby=date&order=desc',
};

export const applyStateAtom = atom(initialState);

/**
 * A Mapper between the filter name coming from the backend and the filter name in the app.
 *
 *
 * @type {{wprm_fuel_type: string, wprm_main_ingredient: string, wprm_featured: string, wprm_course: string, wprm_difficulty: string, wprm_cooking_time: string, wprm_diet: string, wprm_style: string}}
 */
export const TAX_MAP = {
    wprm_main_ingredient: 'mainIngredients',
    wprm_difficulty: 'effortLevel',
    wprm_cooking_time: 'cookingTime',
    wprm_course: 'course',
    wprm_diet: 'diet',
    wprm_style: 'style',
    wprm_fuel_type: 'fuelType',
    wprm_featured: 'featured',
};
